import router from '@/router'
let routesWhiteList=['/login', '/register', '/404', '/401','/see'];
router.beforeResolve(async (to, from, next) => {
  let hasToken = localStorage.getItem('token');
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (routesWhiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
  document.title = getPageTitle(to.meta.title)
})
function getPageTitle(pageTitle) {
  let title="享尚学";
  if (pageTitle) return `${title}-${pageTitle}`
  return `${title}`
}
router.afterEach((to,from) => {
})
